import { MemberCard } from './MemberRow';
import type { MembersPageProps } from './membersPageProps';
import type { OrgMember } from '../../services/org.service';

interface MembersMobileListProps extends MembersPageProps {
  filteredMembers: OrgMember[];
  members: OrgMember[];
}

export function MembersMobileList({ filteredMembers, members, selfUid, toggling, onToggleDisabled, roles, onChangeRole }: MembersMobileListProps) {
  const activeAdmins = members.filter(m => m.role === 'admin' && !m.isDisabled);
  const isLastActiveAdmin = activeAdmins.length === 1;

  return (
    <div className="divide-y divide-green-100 sm:hidden">
      {filteredMembers.map((member: OrgMember) => (
        <MemberCard
          key={member.uid}
          member={member}
          isSelf={member.uid === selfUid}
          isToggling={toggling[member.uid] ?? false}
          onToggleDisabled={onToggleDisabled}
          isLastActiveAdmin={isLastActiveAdmin && member.role === 'admin' && !member.isDisabled}
          roles={roles}
          onChangeRole={onChangeRole}
        />
      ))}
    </div>
  );
}
